import React from "react";
import Typography from "@mui/material/Typography";
import Video from '../../assets/masterPlan.mp4';
import MasterPlanImage from '../../assets/masterPlan.webp';
import Container  from "@mui/material/Container";
import LandTableInformation from "./LandTableInformation";
import {LOTES_STATUS} from '../../utils/constant';
import SolaresInfo from "./SolaresInfo";

const allDataTables = [
    // { id: 1, loteID: '1', meters: 1106.71, status: LOTES_STATUS.SOLD, pricePerMeter: 40 },
    { id: 2, loteID: '2', meters: 4500, status: LOTES_STATUS.SOLD, type: 'standard', pricePerMeter: 40 },
    { id: 3, loteID: '3', meters: 4244.91, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 4, loteID: '4', meters: 1338.35, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 5, loteID: '5', meters: 999.15, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 6, loteID: '6', meters: 1176.08, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 7, loteID: '7', meters: 1735.51, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 8, loteID: '8', meters: 1409.08, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 9, loteID: '9', meters: 1695.77, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 10, loteID: '10', meters: 2289.53, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 11, loteID: '11', meters: 2060.75, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 12, loteID: '12', meters: 1687.70, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 13, loteID: '13', meters: 2656.65, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 14, loteID: '14', meters: 5127.89, status: LOTES_STATUS.AVAILABLE, type: 'premium', pricePerMeter: 45 },
    { id: 15, loteID: '15', meters: 3811.35, status: LOTES_STATUS.AVAILABLE, type: 'premium', pricePerMeter: 45 },
    { id: 16, loteID: '16', meters: 1233.09, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 17, loteID: '17', meters: 1308.69, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 18, loteID: '18', meters: 1452.25, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 19, loteID: '19', meters: 1620.64, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 20, loteID: '20', meters: 1468.19, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 21, loteID: '21', meters: 1522.18, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 22, loteID: '22', meters: 1206.48, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 23, loteID: '23', meters: 1525.34, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 24, loteID: '24', meters: 1833.30, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 25, loteID: '25', meters: 3094.79, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 26, loteID: '26', meters: 2201.12, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 27, loteID: '27', meters: 2295.91, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 28, loteID: '28', meters: 2685.87, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 29, loteID: '29', meters: 1908.74, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 30, loteID: 30, meters: 1531.24, status: LOTES_STATUS.SOLD, type: 'standard', pricePerMeter: 40 },
    { id: 31, loteID: '31', meters: 2242.41, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 32, loteID: '32', meters: 2194.13, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 33, loteID: '33', meters: 1751.66, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 34, loteID: '34', meters: 2047.03, status: LOTES_STATUS.AVAILABLE, type: 'standard', pricePerMeter: 40 },
    { id: 35, loteID: '35', meters: 3088.62, status: LOTES_STATUS.AVAILABLE, type: 'premium', pricePerMeter: 45 },
    { id: 36, loteID: '36', meters: 1709.99, status: LOTES_STATUS.AVAILABLE, type: 'premium', pricePerMeter: 45 },
    { id: 37, loteID: '37', meters: 1932.62, status: LOTES_STATUS.AVAILABLE, type: 'premium', pricePerMeter: 45 },
    // { id: 38, loteID: '38', meters: 3104.99, status: LOTES_STATUS.AVAILABLE, type: 'premium', pricePerMeter: 45 },
    { id: 39, loteID: '39', meters: 2803.01, status: LOTES_STATUS.AVAILABLE, type: 'premium', pricePerMeter: 45 },
    { id: 40, loteID: '40', meters: 2147.75, status: LOTES_STATUS.AVAILABLE, type: 'premium', pricePerMeter: 45 },
    { id: 41, loteID: '41', meters: 2215.62, status: LOTES_STATUS.AVAILABLE, type: 'premium', pricePerMeter: 45 },
];
const dataTable1 = allDataTables.slice(0, 10);
const dataTable2 = allDataTables.slice(10, 20);
const dataTable3 = allDataTables.slice(20, 30);
const dataTable4 = allDataTables.slice(30, 41);

const MasterPlan = () => {
    const [resetResize, setResetResize] = React.useState(false);

    const handleResize = (image) => {

        if (resetResize) {
            image.target.style.transform = "scale(1)";
            image.target.style.transition = "transform 0.25s ease";
            setResetResize(false);
        } else {
            image.target.style.transform = "scale(1.5)";
            image.target.style.transition = "transform 0.25s ease";
            setResetResize(true);
        }
    }

    return (
        <div className="master-plan" id='master-plan'>
            <Typography variant="h3" sx={{color: "var(--primary-color)", fontSize: '30px', fontWeight: 'bold', marginY: '40px'}} className='section-title'>Master Plan</Typography>

            <Container sx={{ marginBottom: '40px', width: '100%', height: '100%', display: 'flex', minWidth: 'auto'}}>
                <img src={MasterPlanImage} className='master-plan-image' onClick={handleResize} alt='Master Plan image'/>
            </Container>

            <SolaresInfo data={allDataTables}></SolaresInfo>
            <Container className='lotes-tables'>
                <LandTableInformation rows={dataTable1}></LandTableInformation>
                <LandTableInformation rows={dataTable2}></LandTableInformation>
                <LandTableInformation rows={dataTable3}></LandTableInformation>
                <LandTableInformation rows={dataTable4}></LandTableInformation>
            </Container>

            <Container sx={{ marginY: '40px'}}>
                <video src={Video} controls autoPlay={true} width="100%" height="auto"/>
            </Container>
        </div>
    );
}

export default MasterPlan;
